import { pathJoin } from 'src/reducers/routing/utils'

export const createMetaValueRoutesMap = (prefix: string) => ({
  ':id': (id = ':id') => pathJoin(prefix)(id).chain,
})
